import React , { useState, useEffect }from 'react';
import Modal from '../../../../Components/Modal';
import {
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import Button from '../../../../Components/Button';
import { SuccessAlert, ErrorAlert } from '../../../../Components/Alert';
import useAxiosCall from '../../../../Hooks/useAxiosCall';
import DataTable from '../../../../Components/DataTable';

const UserHistory = ({isOpen, onClose}) => {
    const [alert, setAlert] = useState({ type: '', message: '' });
    const { makeApiCall } = useAxiosCall();
    const [updated, setUpdated] = useState(false);
    const [userHistoryData, setUserHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Mock data - replace with actual API call
    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            // Simulate API call
            setTimeout(() => {
                const mockData = Array.from({ length: 50 }, (_, index) => ({
                    id: index + 1,
                    ip: '192.145.14.14',
                    loginDate: '10/21/2024 08:15 AM',
                    activity: index % 3 === 0 ? 'Login' : index % 3 === 1 ? 'Logout' : 'Page View'
                }));
                setUserHistoryData(mockData);
                setLoading(false);
            }, 1000);
        }
    }, [isOpen]);

    // Define table columns
    const columns = [
        {
            key: 'ip',
            title: 'IP',
            headerStyle: { width: '30%' }
        },
        {
            key: 'loginDate',
            title: 'Login Date',
            headerStyle: { width: '40%' }
        },
        {
            key: 'activity',
            title: 'Activity',
            headerStyle: { width: '30%' },
            render: (value, record) => (
                <span className={`badge ${
                    value === 'Login' ? 'bg-success' : 
                    value === 'Logout' ? 'bg-warning' : 'bg-info'
                }`}>
                    {value}
                </span>
            )
        }
    ];
    
    const handleApiCallSuccess = (data) => {
        setAlert({ type: 'success', message: data.message});
    };
    
    const handleApiCallError = (errorMessage) => {
        setAlert({ type: 'error', message: errorMessage });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="l">
            <Modal.Header>User History</Modal.Header>
            {alert.type === 'success' && <SuccessAlert success={true} messages={[alert.message]} resetAlert={setAlert} />}
            {alert.type === 'error' && <ErrorAlert error={true} messages={[alert.message]} resetAlert={setAlert} />}
            <Modal.Body>
                <MDBRow>
                    <MDBCol size='12'>
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                data={userHistoryData}
                                columns={columns}
                                itemsPerPage={10}
                                showPagination={true}
                                showInfo={true}
                            />
                        )}
                    </MDBCol>
                </MDBRow>
            </Modal.Body>
            <Modal.Footer>
                <div className='d-flex justify-content-center'>
                    <Button onClick={onClose} color='secondary'>
                        Close
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default UserHistory;
